"use client";

import React, { useState, useEffect } from 'react';
import AppShell from '../../../components/AppShell';
import { Card, CardContent } from '../../../components/ui/card';
import { Select, SelectItem } from '../../../components/ui/select';
import { Button } from '../../../components/ui/button';
import ToggleSwitch from './components/ToggleSwitch';

const API = process.env.REACT_APP_API_BASE;

export default function ReplyBotSettings() {
  const [tone, setTone] = useState('friendly');
  const [language, setLanguage] = useState('en');
  const [ctaStyle, setCtaStyle] = useState('direct');
  const [autoReplyInstagram, setAutoReplyInstagram] = useState(true);
  const [autoReplyWhatsApp, setAutoReplyWhatsApp] = useState(true);
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    // fetchUserSettings().then(...)
  }, []);

  const handleSave = () => {
    setLoading(true);
    const config = {
      tone,
      language,
      ctaStyle,
      autoReplyInstagram,
      autoReplyWhatsApp,
    };
    console.log('Saving config:', config);
    setTimeout(() => setLoading(false), 1000);
  };

  const handleDeleteUserData = async () => {
    const confirmed = window.confirm('Are you sure you want to delete all WhatsApp and Instagram data for this user?');
    if (!confirmed) return;

    setDeleting(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API}/api/whatsapp/delete-user-data`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();
      if (res.ok) {
        alert('User data deleted successfully.');
      } else {
        alert(data.message || 'Failed to delete user data.');
      }
    } catch (err) {
      alert('An error occurred while deleting user data.');
    }
    setDeleting(false);
  };

  return (
    <AppShell>
      <div className="col-span-12 space-y-12">
        <div className="max-w-3xl mx-auto py-10 px-4 space-y-6">
          <h1 className="text-2xl font-semibold mb-2">ReplyBot Settings</h1>

          <Card>
            <CardContent className="p-6 space-y-4">
              <h2 className="text-lg font-semibold">Brand Voice</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <Select label="Tone" value={tone} onValueChange={setTone}>
                  <SelectItem value="friendly">Friendly</SelectItem>
                  <SelectItem value="professional">Professional</SelectItem>
                  <SelectItem value="fun">Fun</SelectItem>
                </Select>
                <Select label="Language" value={language} onValueChange={setLanguage}>
                  <SelectItem value="en">English</SelectItem>
                  <SelectItem value="ar">Arabic</SelectItem>
                  <SelectItem value="hi">Hindi</SelectItem>
                </Select>
                <Select label="CTA Style" value={ctaStyle} onValueChange={setCtaStyle}>
                  <SelectItem value="direct">Direct</SelectItem>
                  <SelectItem value="soft">Soft</SelectItem>
                  <SelectItem value="promo">Promotional</SelectItem>
                </Select>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6 space-y-4">
              <h2 className="text-lg font-semibold">Auto-Reply Settings</h2>
              <ToggleSwitch
                label="Enable AI Auto-Reply for Instagram DMs"
                checked={autoReplyInstagram}
                onCheckedChange={setAutoReplyInstagram}
              />
              <ToggleSwitch
                label="Enable AI Auto-Reply for WhatsApp"
                checked={autoReplyWhatsApp}
                onCheckedChange={setAutoReplyWhatsApp}
              />
            </CardContent>
          </Card>

          <div className="flex gap-4">
            <Button onClick={handleSave} disabled={loading} className="mt-4">
              {loading ? 'Saving...' : 'Save Settings'}
            </Button>

            <Button
              variant="destructive"
              onClick={handleDeleteUserData}
              disabled={deleting}
              className="mt-4"
            >
              {deleting ? 'Deleting...' : 'Delete All User Data'}
            </Button>
          </div>
        </div>
      </div>
    </AppShell>
  );
}
